const loc_it_strings = {
    "Login": {
        "HEADING": "Accesso alla piattaforma FOLBB-ID",
        "LOGIN": "Accesso",
        "USER": "Utente",
        "PASSWORD": "Password",
        "LOGIN_FAIL": "Accesso non riuscito",
        "LOGIN_FIELD_REQUIRED": "Il campo \"Nome utente\" è obbligatorio",
        "PASSWORD_FIELD_REQUIRED": "Il campo \"Password\" è obbligatorio",
        "FORGOT_PASSWORD": "Hai dimenticato la password?",
        "DIFFERENT_ACCOUNT": "Accedi con un account diverso",
        "NO_ACCOUNT": "Non hai un account?",
        "REGISTER": "Registrati con FOLBB digital",
        "CHANGE_DENIED_TEXT": "Per modificare la tua AD-password, utilizza ad esempio OWA, o contatta il tuo servizio assistenza."
    },
    "Dashboard": {
        "DASHBOARD_TEXT": "Dashboard",
        "ACTION_TEXT": "Azioni",
        "CHANGE_PASSWORD_TEXT": "Modifica la password",
        "MY_APPLICATIONS_TEXT": "Le mie applicazioni FOLBB",
        "APPLICATIONS_TEXT": "Applicazioni FOLBB",
        "USERS_LIST_TEXT": "Gestione utente"
    },
    "DashboardHome": {
        "ACTION_TEXT": "Dashboard",
        "MY_APPLICATIONS_TEXT": "Le mie applicazioni FOLBB",
        "APPLICATIONS_TEXT": "Applicazioni FOLBB"
    },
    "Header": {
        "USER_MENU_TEXT": "Menu utente",
        "ACTION_TEXT": "Azioni",
        "CHANGE_PASSWORD_TEXT": "Modifica password",
        "USERS_LIST_TEXT": "Gestione utente",
        "USER_GROUPS": "Roles"
    },
    "Credentials": {
        "OLD_PASSWORD": "Vecchia password",
        "NEW_PASSWORD": "Nuova password",
        "CONFIRM_PASSWORD": "Conferma password",
        "PASS_DO_NOT_MATCH": "Le password non corrispondono",
        "PASSWORD_FIELD_REQUIRED": "Il campo \"Password\" è obbligatorio",
        "OLD_PASSWORD_FIELD_REQUIRED": "Il campo \"Vecchia password\" è obbligatorio",
        "SUCCESS_TEXT": "La password è stata correttamente modificata",
        "HEADING": "Modifica credenziali FOLBB-ID",
        "HELP": "Serve aiuto?",
        "SAVE": "Modifica",
        "CANCEL": "Annulla",
        "PASSWORD_CHANGE_ERROR": "Impossibile salvare i dati. Riprova più tardi",
        "PASSWORD_CHANGE_LINK_EXPIRED": "The password reset link is invalid or has expired. Please, request a new link.",
        "PASSWORD_STREIGHT_ERROR": "La password deve contenere almeno 10 caratteri, tra cui minuscole, maiuscole, caratteri speciali, cifre",
        "PASSWORD_REQUIREMENTS_TEXT": "La password deve soddisfare i seguenti requisiti:",
        "LOWERCASE_LETTER_TEXT": "Almeno una lettera",
        "UPPERCASE_LETTER_TEXT": "Almeno una lettera maiuscola",
        "NUMBER_TEXT": "Almeno un numero",
        "SPECIAL_SYMBOL_TEXT": "Almeno un carattere speciale",
        "PASSWORD_LENGTH_TEXT": "Deve contenere almeno 10 caratteri",
        "PASSWORD_RESTRICTION_TEXT": "Il nome, il cognome o il nome utente non possono far parte della password",
        "CHANGE_PASSWORD_TEXT": "Modifica password",
        "ACTION_TEXT": "Azioni",
        "CHANGE_DENIED_TEXT": "Per modificare la tua AD-password, utilizza ad esempio OWA, o contatta il tuo servizio assistenza."
    },
    "CreatePassword": {
        "PASSWORD": "Crea una password",
        "CONFIRM_PASSWORD": "Conferma password",
        "PASS_DO_NOT_MATCH": "Le password non corrispondono",
        "PASSWORD_FIELD_REQUIRED": "Il campo \"Password\" è obbligatorio",
        "SUCCESS_TEXT": "I dati sono stati correttamente salvati",
        "HEADING": "Crea password",
        "HELP": "Serve aiuto?",
        "SAVE": "Modifica",
        "CANCEL": "Annulla",
        "PASSWORD_CHANGE_ERROR": "Impossibile salvare i dati. Riprova più tardi",
        "PASSWORD_CHANGE_LINK_EXPIRED": "The password reset link is invalid or has expired. Please, request a new link.",
        "PASSWORD_STREIGHT_ERROR": "La password deve contenere almeno 10 caratteri, tra cui minuscole, maiuscole, caratteri speciali, cifre",
        "PASSWORD_REQUIREMENTS_TEXT": "La password deve soddisfare i seguenti requisiti:",
        "LOWERCASE_LETTER_TEXT": "Almeno una lettera",
        "UPPERCASE_LETTER_TEXT": "Almeno una lettera maiuscola",
        "NUMBER_TEXT": "Almeno un numero",
        "SPECIAL_SYMBOL_TEXT": "Almeno un carattere speciale",
        "PASSWORD_LENGTH_TEXT": "Deve contenere almeno 10 caratteri",
        "PASSWORD_RESTRICTION_TEXT": "Il nome, il cognome o il nome utente non possono far parte della password",
        "PASSWORD_WAS_SET": "Il link è già stato utilizzato per impostare la password; se non ricordi la password, utilizza la funzione per reimpostare la password.",
        "OLD_PASSWORD_REQUIRED": "Il campo \"Vecchia password\" è obbligatorio",
        "MMID_CHANGE_PASSWORD": "Modifica password",
        "OLD_PASSWORD": "Vecchia password",
        "INVALID_OLD_PASSWORD": "Vecchia password non valida",
        "USER_NOT_FOUND_OR_INACTIVE": "Utente non trovato o inattivo",
        "UNKNOWN_ERROR": "Qualcosa è andato storto, in fase di modifica della password"
    },
    "ForgotPassword": {
        "USER": "E-mail",
        "LOGIN_FAIL": "Inserisci un indirizzo e-mail corretto",
        "LOGIN_FIELD_REQUIRED": "Il campo \"E-mail\" è obbligatorio",
        "HEADING": "Ho dimenticato la password",
        "HELP": "Hai bisogno d'aiuto?",
        "SAVE": "Invia e-mail per reimpostare la password",
        "CANCEL": "Annulla",
        "SUCCESS_TEXT": "Per verificare la ricezione dell'e-mail, controlla la tua cartella della Posta in arrivo.",
        "CHANGE_DENIED_TEXT": "Per modificare la tua AD-password, utilizza ad esempio OWA, o contatta il tuo servizio assistenza.",
        "PASSWORD_RESET_TOO_OFTEN": "La funzione di reimpostazione della password è stata utilizzata troppe volte, riprova più tardi",
        "RESET_FAILED": "Accesso non riuscito",
        "LINK_EXPIRED": "Il link d'accesso è scaduto. Inserisci il tuo indirizzo e-mail per richiedere nuovamente il link d'accesso.",
        "HEADING_EXPIRED": "Il tuo link d'accesso è scaduto",
        "SAVE_EXPIRED": "Richiedi link d'accesso"
    },
    "UsersList": {
        "USERS_LIST_TEXT": "Gestione utente",
        "ACTIVE": "Attivo",
        "INACTIVE": "Inattivo",
        "MMID": "FOLBBID",
        "OU": "Unità organizzativa",
        "ORGANIZATION_UNIT": "Unità di organizzazione",
        "LANGUAGE": "Lingua",
        "OPEN_FILTER": "Apri filtro",
        "CLOSE_FILTER": "Chiudi filtro",
        "RESET": "azzera",
        "RESET_ALL_FILTERS": "Azzera tutti i filtri",
        "SEARCH": "Ricerca",
        "STATUS": "Stato",
        "GROUPS": "Gruppi",
        "SHOW_ALL_DETAILS": "Mostra tutti i dettagli",
        "SHOW_LESS": "Mostra meno",
        "ASCENDING": "Ascendente",
        "DESCENDING": "Discendente",
        "LIST_END": "Termine dell'elenco",
        "SORT_BY_LASTNAME": "Ordina per cognome",
        "SORT_BY_FIRSTNAME": "Ordina per nome",
        "SORT_BY_EMAIL": "Ordina per e-mail",
        "SORT_BY_LANGUAGE": "Ordina per lingua preferita",
        "SORT_BY_STATUS": "Ordina per stato",
        "SORT_BY_OU": "Ordina per OU",
        "SORT_BY_ACCOUNT_NAME": "Sort by Logon Name",
        "EDIT": "Modifica",
        "CREATE": "Nuovo utente",
        "DIGICREATE": "Nuovo utente FOLBB digital",
        "ACTIVATE": "Attiva",
        "DEACTIVATE": "Disattiva",
        "USER_WAS_ACTIVATED": "L'utente è stato attivato",
        "USER_WAS_DEACTIVATED": "L'utente è stato disattivato",
        "ERROR_USER_ACTIVATION": "Si è verificato un errore durante l'attivazione dell'utente",
        "ERROR_USER_DEACTIVATION": "Si è verificato un errore durante la disattivazione dell'utente",
        "SEND_FORGOT_PW_EMAIL": "Invia e-mail per password dimenticata",
        "SEND_FORGOT_PW_EMAIL_GENERIC": "E-mail generica per password dimenticata",
        "SEND_FORGOT_PW_EMAIL_DIGI": "E-mail FOLBB digital per password dimenticata",
        "COMPANY": "Società",
        "SEND_WELCOME_EMAIL": "Invia e-mail di benvenuto",
        "SEND_WELCOME_EMAIL_DIGI": "E-mail di benvenuto di FOLBB digital",
        "SEND_WELCOME_EMAIL_DIGI_NO_PASS": "E-mail di benvenuto di FOLBB digital senza pulsante PW",
        "APPLY_FILTER_FOR_USERS": "Per visualizzare i risultati, utilizza i filtri o la ricerca",
        "GENERATING_EMAIL": "Generazione dell'e-mail in corso...",
        "ERROR_EMAIL_GENERATE": "Errore durante la generazione dell' e-mail...",
        "LOCKED": "Locked",
        "UNLOCK": "Unlock",
        "SET_PASSWORD": "Set password",
        "PHYSICAL_LOCATION": "Location",
        "REQUIRED": "Required",
        "USER_TYPE": "User type",
        "CANONICAL_NAME": "Canonical name"
    },
    "EditUser": {
        "USERS_LIST_TEXT": "Gestione utente",
        "USER_WAS_ACTIVATED": "L'utente è stato attivato",
        "USER_WAS_DEACTIVATED": "L'utente è stato disattivato",
        "ERROR_USER_ACTIVATION": "Si è verificato un errore durante l'attivazione dell'utente",
        "ERROR_USER_DEACTIVATION": "Si è verificato un errore durante la disattivazione dell'utente",
        "LOADING_USER_ERROR": "Si è verificato un errore durante il caricamento dell'utente",
        "FIRSTNAME": "Nome",
        "LASTNAME": "Cognome",
        "EMAIL": "E-mail",
        "ACCOUNT_NAME": "Nome di accesso dell'utente (pre-windows 2000)",
        "LANGUAGE": "Lingua",
        "PRINCIPAL_NAME": "Nome principale utente",
        "OU": "Unità di organizzazione",
        "CLASS_DISPLAY_NAME": "Nome visualizzato",
        "PHONE": "Telefono",
        "WEBSITE": "Sito web",
        "COUNTRY": "Paese",
        "STATE": "Stato",
        "LOCATION": "Città",
        "STREET": "Via",
        "POSTAL_CODE": "Codice postale",
        "COMPANY": "Società",
        "DEPARTMENT": "Dipartimento",
        "PERSONAL_TITLE": "Titolo personale",
        "MANAGER": "Manager",
        "DESCRIPTION": "Descrizione",
        "GROUPS": "Gruppi",
        "SAVE": "Salva",
        "CANCEL": "Annulla",
        "USER_STATUS": "Stato utente",
        "ACTIVE": "Attivo",
        "INACTIVE": "Inattivo",
        "ACTIVATE": "Attiva",
        "DEACTIVATE": "Disattiva",
        "USER_WAS_SAVED": "L'utente è stato salvato",
        "UNKNOWN_ERROR": "Si è verificato un errore sconosciuto in fase di salvataggio dell'utente",
        "PROXY_ADDRESSES": "Indirizzi proxy",
        "BROWSE": "Naviga",
        "REMOVE": "Rimuovi",
        "ONLY_JPG": "Sono consentite solo immagini in formato jpg!",
        "FILE_SIZE": "Le dimensioni del file devono essere inferiori ai 100 KB!",
        "DIMENSIONS": "La dimensione massima consentita per l'immagine è di 96X96 pixel!",
        "SEND_FORGOT_PW_EMAIL": "Invia e-mail per password dimenticata",
        "SEND_FORGOT_PW_EMAIL_GENERIC": "E-mail generica per password dimenticata",
        "SEND_FORGOT_PW_EMAIL_DIGI": "E-mail FOLBB digital per password dimenticata",
        "VIRUS_FOUND": "L'utente non può essere salvato. Nell'allegato è stato rilevato un programma contenente malware. Il file non verrà caricato. Contatta l'amministratore di sistema.",
        "VIRUS_SCANNER_NOT_AVL": "Impossibile scansionare il file per il rilevamento di malware. Riprova più tardi. Se il problema persiste, contatta il tuo amministratore di sistema.",
        "INFO": "Info:",
        "SEND_WELCOME_EMAIL": "Invia e-mail di benvenuto",
        "SEND_WELCOME_EMAIL_DIGI": "E-mail di benvenuto di FOLBB digital",
        "SEND_WELCOME_EMAIL_DIGI_NO_PASS": "E-mail di benvenuto di FOLBB digital senza pulsante PW",
        "SAVING_USER_SPINNER": "Salvataggio dell'utente in corso... Attendi, per favore",
        "DUPLICATE_USER": "L'utente è già esistente",
        "GENERATING_EMAIL": "Generazione dell'e-mail...",
        "ERROR_EMAIL_GENERATE": "Errore durante la generazione dell'e-mail...",
        "UNLOCK": "Unlock",
        "SET_PASSWORD": "Set password",
        "COST_CENTER": "Cost center",
        "JOB_TITLE": "Job title",
        "GENDER": "Gender",
        "USER_NOT_FOUND": "Utente non trovato",
        "USER_TYPE": "User type",
        "CANONICAL_NAME": "Canonical name"
    },
    "ResendWelcome": {
        "GENERATING_EMAIL": "Generazione dell'e-mail di benvenuto..."
    },
    "Shared": {
        "USER_WAS_ACTIVATED": "L'utente è stato attivato",
        "USER_WAS_DEACTIVATED": "L'utente è stato disattivato",
        "ERROR_USER_ACTIVATION": "Si è verificato un errore durante l'attivazione dell'utente",
        "ERROR_USER_DEACTIVATION": "Si è verificato un errore durante la disattivazione dell'utente",
        "EMAIL_WAS_SENT": "L'e-mail è stata correttamente inviata",
        "EMAIL_NOT_SENT_USER_ACTIVE": "L'e-mail non è stata inviata. L'utente risulta già attivo. Utilizza, invece, la funzione \"Invia e-mail per password dimenticata\"",
        "ERROR_EMAIL_SEND": "Si è verificato un errore nel tentativo di invio dell'e-mail",
        "EMAIL_NOT_SENT_USER_INACTIVE": "L'e-mail non è stata inviata. L'utente risulta inattivo. Utilizza la funzione \"Invia e-mail di registrazione a FOLBB digital\".",
        "PASSWORD_RESET_TOO_OFTEN": "La funzione di reimpostazione della password è stata utilizzata troppe volte, riprova più tardi",
        "USER_WAS_UNLOCKED": "User was unlocked",
        "ERROR_UNLOCK_USER": "Error unlocking user"
    }
};

export default loc_it_strings;



// WEBPACK FOOTER //
// ./src/resources/it.js